export const EXPEDIENT_WEEK_DAYS = [
	{ day: 0, label: "Domingo" },
	{ day: 1, label: "Segunda-feira" },
	{ day: 2, label: "Terça-feira" },
	{ day: 3, label: "Quarta-feira" },
	{ day: 4, label: "Quinta-feira" },
	{ day: 5, label: "Sexta-feira" },
	{ day: 6, label: "Sábado" },
] as const;

export const EXPEDIENT_TIME_SLOTS = Array.from({ length: 48 }, (_, i) => {
	const hour = Math.floor(i / 2);
	const minutes = (i % 2) * 30;
	return `${String(hour).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
});

export const EXPEDIENT_MESSAGES = {
	VALIDATION_ERROR: {
		title: "Erro ao atualizar",
		description: "Preencha os horários corretamente antes de atualizar.",
	},
	UPDATE_SUCCESS: {
		title: "Expediente atualizado com sucesso.",
		description:
			"Os dias e horários de expediente foram atualizados com sucesso.",
	},
	UPDATE_ERROR: {
		title: "Erro ao atualizar",
		description: "Não foi possível atualizar o expediente. Tente novamente.",
	},
} as const;
